import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { loadRuntimeConfig } from './utils/config';
import { LicenseManager } from "ag-grid-enterprise";
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));

loadRuntimeConfig()
  .then((config) => {
    // Set AG Grid license globally before any components render
    if (config.agGridLicenseKey) {
      console.log('Setting AG Grid license globally...');
      LicenseManager.setLicenseKey(config.agGridLicenseKey);
      console.log('AG Grid license set globally');
    } else {
      console.warn('AG Grid license key not found in config');
    }

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
  })
  .catch((error) => {
    console.error('Failed to bootstrap config', error);
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
